<template>
  <div class="header-container">
    <div class="header-container-item">
      <img
        v-if="getBnplInstanceType === BNPL_INSTANCE_TYPE.FACTORING"
        alt="instacash-logo-white"
        class="instacash-logo"
        :src="require('@/assets/images/milpay-logo.svg')"
      />
      <img
        v-else-if="
          getBnplInstanceType === BNPL_INSTANCE_TYPE.MERCHANT_FINANCE
        "
        alt="instacash-logo-white"
        class="instacash-logo"
        :src="require('@/assets/images/instacash-logo-white.svg')"
      />
      <b-skeleton v-else width="70" height="20" />
    </div>

    <div class="header-container-item">
      <b-dropdown
        v-if="countries"
        v-model="selectedCountryId"
        position="is-bottom-left"
        :mobile-modal="false"
        aria-role="list"
      >
        <template v-if="selectedCountry" #trigger="{ active }">
          <button class="button is-small" outlined>
            <span v-html="getFlag(selectedCountry.flag)" class="flag"></span>
            <span>{{ selectedCountry.languageIso.split("-")[0] }}</span>
            <!-- <span>{{ selectedCountry.languageIso }}</span> -->
            <b-icon
              icon-pack="fa"
              :icon="active ? 'chevron-up' : 'chevron-down'"
              size="is-small"
            ></b-icon>
          </button>
        </template>

        <b-dropdown-item
          v-for="country in countries"
          :key="country.id"
          :value="country.id"
          aria-role="listitem"
        >
          <div class="country-list-item">
            <div v-html="getFlag(country.flag)" class="flag"></div>
            <div>{{ country.languageName }}</div>
          </div>
        </b-dropdown-item>
      </b-dropdown>

      <div v-if="canAccessPortal" class="back-to-portal" @click="backToPortal">
        {{ $t("mp:header.registration.back_to_portal") }}
        <b-icon icon="chevron-right" type="is-white" size="is-small" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import twemoji from "@twemoji/api";
import { BNPL_INSTANCE_TYPE } from "@/utils/const";

export default {
  name: "RegistrationHeader",
  data() {
    return {
      BNPL_INSTANCE_TYPE,
      selectedCountryId: null,
    };
  },
  computed: {
    ...mapGetters({
      canAccessPortal: "session/canAccessPortal",
      countries: "i18n/countries",
      selectedCountry: "i18n/country",
      getBnplInstanceType: "uiConfigStore/getBnplInstanceType",
    }),
  },
  methods: {
    ...mapMutations({
      setCountryById: "i18n/setCountryById",
    }),
    backToPortal() {
      this.$router.push("/profile");
    },
    getFlag(flag) {
      if (flag) {
        return twemoji.parse(flag, {
          folder: "svg",
          ext: ".svg",
        });
      }
    },
  },
  watch: {
    selectedCountryId: {
      handler(newValue) {
        this.setCountryById(newValue);
      },
      // immediate: true,
    },
    selectedCountry: {
      handler(newValue) {
        this.selectedCountryId = newValue?.id;
      },
      immediate: true,
    },
  },
  created() {
    // if (this.selectedCountry?.id) {
    //   this.selectedCountryId = this.selectedCountry.id;
    // }
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/colors.scss";

.header-container {
  display: flex;
  background-color: $grey-dark;
  padding-bottom: 1rem;
  padding-top: 1rem;
  padding-left: 2rem;
  padding-right: 1rem;
  z-index: 10;
  height: 3.5rem;
  color: $white;

  .header-container-item {
    flex: 1;
    display: flex;
    gap: 1rem;

    .button {
      display: flex;
      align-items: center;
      justify-content: center;
      text-transform: uppercase;
      height: 24px;
      padding: 0;
      color: $white;
      background: none;
      border: none;
      gap: 5px;
      z-index: 1;

      &:focus {
        outline: none;
        box-shadow: none;
      }

      span {
        width: 18px;
      }

      .icon {
        margin: 0;
        width: 18px;
        height: 18px;

        svg {
          width: 10px;
          height: 10px;
        }
      }

      .flag {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        width: 18px;
        height: 18px;
      }
    }

    &:last-of-type {
      justify-content: flex-end;
    }
  }
}

.instacash-logo {
  padding-bottom: 4px;
}

.country-list-item {
  display: flex;
  gap: 0.5rem;
  height: 24px;

  .flag {
    display: flex;
    align-items: center;
    width: 24px;
    height: 24px;
    font-size: 24px;
  }
}

.back-to-portal {
  display: flex;
  // margin-right: 1rem;
  margin-top: 0.25rem;

  font-size: 14px;
  // margin-left: auto;
  color: white;

  cursor: pointer;

  span {
    margin-left: 0.5rem;
  }
}
</style>
